import React, { useState, useCallback, useEffect } from "react";
import {
  Col,
  Input,
  Label,
  Row,
  TabPane,
  Spinner,
  Form,
  Button,
} from "reactstrap";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";
import InputMask from "react-input-mask";
import { NumericFormat } from "react-number-format";

const apiClient = new APIClient();

const TabPerfil = ({ user_id }) => {
  const [loading, setLoading] = useState(false);
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [tipoCliente, setTipoCliente] = useState("cpf");
  const [cpf, setCpf] = useState("");
  const [situacao, setSituacao] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [rg, setRg] = useState("");
  const [telefone, setTelefone] = useState("");
  const [limiteMensal, setLimiteMensal] = useState(0);
  const [limiteAnual, setLimiteAnual] = useState(0);
  const [verificacao, setVerificacao] = useState("");
  const [indicadoPor, setIndicadoPor] = useState("");
  const [codigoParceiro, setCodigoParceiro] = useState("");
  const [nivelKyc, setNivelKyc] = useState(0);
  const [endereco, setEndereco] = useState("");
  const [itemsKyc, setItemsKyc] = useState([]);
  const [limiteMensalDisabled, setLimiteMensalDisabled] = useState(false);
  const [password, setPassword] = useState("");

  const changePassword = async (user_id) => {
    setLoading(true);
    const response = await apiClient.put("/guest/change-password", {
      user_id: user_id,
      password: password,
      password_confirmation: password,
    });

    if (response.sucesso) {
      toast.success(response.mensagem);
      setPassword("");
    } else {
      toast.error(response.mensagem || "Erro ao alterar a senha!");
    }
    setLoading(false);
  };

  const fetchClientData = useCallback(async (user_id) => {
    const response = await apiClient.get(`/client/get-client-data/${user_id}`);

    if (response.sucesso) {
      return response.dados;
    } else {
      toast.error(response.mensagem);
      return [];
    }
  }, []);

  const resetKyc = async () => {
    const response = await apiClient.put(`/client/reset-kyc/${user_id}`);

    if (response.sucesso) {
      toast.success(response.mensagem);
    } else {
      toast.error(response.mensagem);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let updatedFields = {};
    if (nome) updatedFields.nome_completo = nome;
    if (email) updatedFields.email = email;
    if (cpf) updatedFields.cpf_cnpj = cpf;
    if (tipoCliente)
      updatedFields.pessoa_fisica = tipoCliente === "cpf" ? true : false;
    if (situacao) updatedFields.status_cpf = situacao;
    if (dataNascimento) updatedFields.nascimento = dataNascimento;
    if (rg) updatedFields.rg = rg;
    if (telefone) updatedFields.telefone = telefone;
    if (limiteMensal) updatedFields.negociar_mensalmente = limiteMensal;
    if (limiteAnual) updatedFields.limite_anual_brl = limiteAnual;
    if (verificacao) updatedFields.metamap_status_verification = verificacao;
    if (indicadoPor && indicadoPor !== "Sem Indicação")
      updatedFields.indicacao = indicadoPor;
    if (codigoParceiro) updatedFields.codigo_parceiro = codigoParceiro;
    if (nivelKyc) updatedFields.nivel_kyc = nivelKyc;
    if (endereco) updatedFields.endereco = endereco;

    const response = await apiClient.put(
      `/client/clientes/${user_id}`,
      updatedFields
    );

    if (response.sucesso) {
      toast.success(response.mensagem);
    } else {
      toast.error(response.mensagem || "Erro na API");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const retorno = await fetchClientData(user_id);
      setNome(retorno.clientData.nome_completo);
      setEmail(retorno.clientData.email);
      setCpf(retorno.clientData.cpf_cnpj);
      setTipoCliente(retorno.clientData.pessoa_fisica ? "cpf" : "cnpj");
      setSituacao(retorno.clientData.status_cpf);
      setDataNascimento(retorno.clientData.nascimento);
      setRg(retorno.clientData.rg);
      setTelefone(retorno.clientData.telefone);
      setLimiteMensal(parseFloat(retorno.clientData.negociar_mensalmente));
      setLimiteAnual(parseFloat(retorno.clientData.limite_anual_brl));
      setVerificacao(
        retorno.clientData.metamap_status_verification !== "rejected" &&
          retorno.clientData.metamap_status_verification !== "verified" &&
          retorno.clientData.metamap_status_verification !== "reviewNeeded"
          ? "pending"
          : retorno.clientData.metamap_status_verification
      );
      setIndicadoPor(
        retorno.clientData.indicacao === "fort"
          ? "Sem Indicação"
          : retorno.clientData.indicacao
      );
      setCodigoParceiro(retorno.clientData.codigo_parceiro);
      setNivelKyc(retorno.clientData.nivel_kyc);
      setEndereco(retorno.clientData.endereco);
      setLimiteMensalDisabled(retorno.clientData.nivel_kyc < 3);
      setItemsKyc(retorno.clientData?.kyc?.items || []);
      setLoading(false);
    };
    fetchData();
  }, [fetchClientData, user_id]);

  const formatCurrency = (value) => {
    if (!value) {
      return "R$ 0,00";
    }
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber || !phoneNumber.startsWith("55")) {
      return phoneNumber;
    }

    const formattedNumber = phoneNumber.replace(
      /^(\d{2})(\d{2})(\d{1})(\d{4})(\d{4})$/,
      "+$1 ($2) $3 $4-$5"
    );
    return formattedNumber;
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return "";
    }

    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const reFormatDate = (dateString) => {
    if (!dateString) {
      return "";
    }

    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };

  const formatNome = (event) => {
    let value = event.target.value.toUpperCase();
    value = value.replace(/[^A-Za-z\s]/g, "");
    setNome(value);
  };

  const formatEmail = (event) => {
    let value = event.target.value;
    value = value.replace(/[^a-zA-Z0-9.\-_@]+/g, "");

    const atSymbolCount = value.split("@").length - 1;
    if (atSymbolCount > 1) {
      const index = value.lastIndexOf("@");
      value = value.slice(0, index) + value.slice(index + 1);
    }

    setEmail(value);
  };

  return (
    <TabPane tabId="1">
      {nivelKyc === 0 && (
        <Row style={{ marginBottom: "25px" }}>
          <Col lg={4}>
            <Button
              color="primary"
              onClick={() => {
                resetKyc();
                setVerificacao("pending");
              }}
            >
              Resetar processo KYC
            </Button>
          </Col>
        </Row>
      )}
      <Row style={{ marginBottom: "25px" }}>
        <Col lg={6}>
          <div className="d-flex gap-2">
            <div className="position-relative flex-grow-1">
              <Input
                type="text"
                className="form-control pe-5"
                placeholder="Digite ou gere uma nova senha"
                value={password}
                onChange={(e) => {
                  const value = e.target.value;
                  if (
                    value.length <= 20 &&
                    /^[A-Za-z0-9#@!$%&]*$/.test(value)
                  ) {
                    setPassword(value);
                  }
                }}
              />
              <div
                className="position-absolute end-0 top-50 translate-middle-y me-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (password) {
                    navigator.clipboard.writeText(password);
                    toast.success(
                      "Senha copiada para a área de transferência!"
                    );
                  }
                }}
              >
                <i className="ri-file-copy-line"></i>
              </div>
            </div>
            <Button
              color="info"
              onClick={() => {
                const lowercase = "abcdefghijklmnopqrstuvwxyz";
                const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const special = "#@!$%&";

                // Garantir pelo menos um de cada tipo
                let newPassword = "";
                newPassword += lowercase.charAt(
                  Math.floor(Math.random() * lowercase.length)
                );
                newPassword += uppercase.charAt(
                  Math.floor(Math.random() * uppercase.length)
                );
                newPassword += numbers.charAt(
                  Math.floor(Math.random() * numbers.length)
                );
                newPassword += special.charAt(
                  Math.floor(Math.random() * special.length)
                );

                // Completar até 8 caracteres
                const allChars = lowercase + uppercase + numbers + special;
                for (let i = 4; i < 8; i++) {
                  newPassword += allChars.charAt(
                    Math.floor(Math.random() * allChars.length)
                  );
                }

                // Embaralhar a senha
                newPassword = newPassword
                  .split("")
                  .sort(() => Math.random() - 0.5)
                  .join("");

                setPassword(newPassword);
              }}
            >
              Gerar Senha
            </Button>
            <Button
              color="success"
              onClick={() => changePassword(user_id)}
              disabled={!password || password.length < 8}
            >
              Confirmar
            </Button>
          </div>
          <small className="text-muted">
            A senha deve conter pelo menos 8 caracteres, incluindo uma letra
            maiúscula, uma minúscula, um número e um caractere especial
            (#@!$%&).
          </small>
        </Col>
      </Row>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            padding: "20px",
          }}
        >
          <Spinner height={100} width={100} />
        </div>
      ) : (
        <Form>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="radioOptions" className="form-label">
                  Tipo
                </Label>
                <Row id="radioOptions">
                  <Col lg={6}>
                    <Input
                      className="form-check-input"
                      type="radio"
                      name="radioTipo"
                      id="radioCPF"
                      defaultValue="cpf"
                      checked={tipoCliente === "cpf"}
                      onChange={(e) => setTipoCliente(e.target.value)}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="radioCPF"
                      style={{ marginLeft: "10px" }}
                    >
                      Pessoa Física
                    </Label>
                  </Col>
                  <Col lg={6}>
                    <Input
                      className="form-check-input"
                      type="radio"
                      name="radioTipo"
                      id="radioCNPJ"
                      defaultValue="cnpj"
                      checked={tipoCliente === "cnpj"}
                      onChange={(e) => setTipoCliente(e.target.value)}
                    />
                    <Label
                      className="form-check-label"
                      htmlFor="radioCNPJ"
                      style={{ marginLeft: "10px" }}
                    >
                      Pessoa Jurídica
                    </Label>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">
                  {tipoCliente === "cpf" ? "Nome Completo" : "Razão Social"}
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  value={nome ? nome : ""}
                  onChange={formatNome}
                  maxLength={250}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">E-mail</Label>
                <Input
                  type="email"
                  className="form-control"
                  value={email ? email : ""}
                  onChange={formatEmail}
                  maxLength={150}
                />
              </div>
            </Col>
            {tipoCliente === "cpf" ? (
              <>
                <Col lg={6}>
                  <div className="mb-3">
                    <Label className="form-label">CPF</Label>
                    <InputMask
                      mask="999.999.999-99"
                      value={cpf ? cpf : ""}
                      placeholder="000.000.000-00"
                      onChange={(e) => setCpf(e.target.value)}
                    >
                      {(inputProps) => (
                        <Input
                          type="text"
                          className="form-control"
                          {...inputProps}
                        />
                      )}
                    </InputMask>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Label className="form-label">Situação do CPF</Label>
                    <select
                      className="form-control"
                      value={situacao ? situacao : ""}
                      onChange={(e) => setSituacao(e.target.value)}
                    >
                      <option value=""></option>
                      <option value="REGULAR">REGULAR</option>
                      <option value="IRREGULAR">IRREGULAR</option>
                    </select>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <Label className="form-label">RG</Label>
                    <InputMask
                      mask="99.999.999-9"
                      value={rg ? rg : ""}
                      onChange={(e) => setRg(e.target.value)}
                    >
                      {(inputProps) => (
                        <Input
                          type="text"
                          className="form-control"
                          {...inputProps}
                        />
                      )}
                    </InputMask>
                  </div>
                </Col>
              </>
            ) : (
              <>
                <Col lg={6}>
                  <div className="mb-3">
                    <Label className="form-label">CNPJ</Label>
                    <InputMask
                      mask="99.999.999/9999-99"
                      placeholder="00.000.000/0000-00"
                      value={cpf ? cpf : ""}
                      onChange={(e) => setCpf(e.target.value)}
                    >
                      {(inputProps) => (
                        <Input
                          type="text"
                          className="form-control"
                          {...inputProps}
                        />
                      )}
                    </InputMask>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <Label className="form-label">Situação do CNPJ</Label>
                    <select
                      className="form-control"
                      value={situacao ? situacao : ""}
                      onChange={(e) => setSituacao(e.target.value)}
                    >
                      <option value=""></option>
                      <option value="REGULAR">REGULAR</option>
                      <option value="IRREGULAR">IRREGULAR</option>
                    </select>
                  </div>
                </Col>
              </>
            )}

            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">
                  {tipoCliente === "cpf" ? "Nascimento" : "Início da Empresa"}
                </Label>
                <Input
                  type="date"
                  className="form-control"
                  value={dataNascimento ? dataNascimento : ""}
                  onChange={(e) => setDataNascimento(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Telefone</Label>
                <InputMask
                  mask="(99) 99999-9999"
                  value={telefone ? telefone : ""}
                  onChange={(e) => setTelefone(e.target.value)}
                >
                  {(inputProps) => (
                    <Input
                      type="text"
                      className="form-control"
                      {...inputProps}
                    />
                  )}
                </InputMask>
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Verificação KYC</Label>
                <select
                  className="form-control"
                  value={verificacao ? verificacao : "pending"}
                  onChange={(e) => setVerificacao(e.target.value)}
                >
                  <option value="rejected" style={{ color: "darkred" }}>
                    Reprovado
                  </option>
                  <option value="verified" style={{ color: "darkgreen" }}>
                    Aprovado
                  </option>
                  <option value="reviewNeeded" style={{ color: "darkmagenta" }}>
                    Pendente
                  </option>
                  <option value="pending" style={{ color: "darkyellow" }}>
                    Aguardando
                  </option>
                </select>
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Nível KYC</Label>
                <select
                  className="form-control"
                  value={nivelKyc ? nivelKyc : "0"}
                  onChange={(e) => {
                    setNivelKyc(e.target.value);
                    if (e.target.value === "1") {
                      setLimiteMensal(500);
                      setLimiteAnual(6000);
                      setLimiteMensalDisabled(true);
                    } else if (e.target.value === "2") {
                      setLimiteMensal(2000);
                      setLimiteAnual(24000);
                      setLimiteMensalDisabled(true);
                    } else setLimiteMensalDisabled(false);
                  }}
                >
                  <option value="0">Não realizado</option>
                  <option value="1">Básico</option>
                  <option value="2">Avançado</option>
                  <option value="3">Personalizado</option>
                </select>
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Limite Mensal</Label>
                <NumericFormat
                  className="form-control"
                  id="compraDiaria"
                  placeholder="R$ 0,00"
                  value={limiteMensal ? limiteMensal : ""}
                  onValueChange={({ value }) => {
                    setLimiteMensal(parseFloat(value));
                    setLimiteAnual(parseFloat(value) * 12);
                  }}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix="R$ "
                  allowNegative={false}
                  disabled={limiteMensalDisabled}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Limite Anual</Label>
                <Input
                  readOnly
                  disabled={limiteMensalDisabled}
                  type="text"
                  className="form-control"
                  value={formatCurrency(limiteAnual)}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Indicado Por</Label>
                <Input
                  type="text"
                  className="form-control"
                  value={indicadoPor ? indicadoPor : "Sem Indicação"}
                  onChange={(e) => setIndicadoPor(e.target.value)}
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <Label className="form-label">Código Parceiro</Label>
                <Input
                  type="text"
                  className="form-control"
                  value={codigoParceiro ? codigoParceiro : ""}
                  onChange={(e) => setCodigoParceiro(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3 pb-2">
                <Label className="form-label">Endereço</Label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea"
                  rows="3"
                  value={endereco ? endereco : ""}
                  onChange={(e) => setEndereco(e.target.value)}
                ></textarea>
              </div>
              <div className="text-end">
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Salvar
                </button>
              </div>
            </Col>
          </Row>
          <Row>
            {itemsKyc && itemsKyc.length > 0 && (
              <>
                <Col lg={12}>
                  <h5 className="mb-4">Verificações KYC</h5>
                </Col>
                {itemsKyc.map((item, index) => (
                  <Col md={4} key={index} className="mb-3">
                    <div className="d-flex align-items-center mb-2">
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          borderRadius: "50%",
                          backgroundColor:
                            item.status === "VALID" && item.result_status === "APPROVED"
                              ? "#28a745"
                              : item.status === "VALID" || item.result_status === "APPROVED"
                              ? "#ffc107"
                              : "#dc3545",
                          marginRight: "8px",
                        }}
                      />
                      <Label className="form-label mb-0">{item.code}</Label>
                    </div>
                    <small className="text-muted">{item.description}</small>
                  </Col>
                ))}
              </>
            )}
          </Row>
        </Form>
      )}
    </TabPane>
  );
};

export default TabPerfil;
